module.exports = __webpack_public_path__ + "static/takamol-68cf72ebd4fb22cda5c0252791313635.webm";